export default __webpack_public_path__ + "static/avatar-barbara-johnson-529131c34b99ad73a2eeab65bb544671.jpg";